import { MenuItem } from "../components/navbar";
import { useAuthStore } from "../stores/auth";
import { useLocale } from "../stores/locale";

export function useMenu(): MenuItem[] {
  const { locale: t } = useLocale((state) => state);
  const isAuth = useAuthStore((state) => state.isAuth);

  return [
    ...(isAuth
      ? [
          {
            title: t.time.time,
            slug: "/time",
          },
          {
            title: t.report.report,
            slug: "/report",
          },
        ]
      : [
          {
            title: t.home.home,
            slug: "/home",
          },
          { separator: true },
          {
            title: t.login.login,
            slug: "/login",
          },
        ]),
  ] as MenuItem[];
}
